
<div fxLayout="column" *ngIf="loading === 0">
  <product-details-top-bar
    [product]="product"
    [productCompany]="productCompany"
    [isAddMode]="isAddMode"
    [isAuthorizedForProductsCompany]="isAuthorizedForProductsCompany"
    >
  </product-details-top-bar>

  <mat-card>
    <mat-card-content>

      <mat-tab-group preserveContent animationDuration="0ms" (selectedTabChange)="onTabChanged($event)" [selectedIndex]="selectedTabIndex">
        <mat-tab label="Details">
          <ng-template matTabContent>
            
            <product-details-tab *ngIf="product"
              [product]="product"
              [productCompany]="productCompany"
              [isAddMode]="isAddMode"
              [readOnly]="readOnlyProductDetailsTab()"
              (createProduct)="createProduct()"
              >
            </product-details-tab>

          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canAccessProductThemesTab()" label="Themes">
          <ng-template matTabContent>
            
            <product-themes-tab *ngIf="product"
              [product]="product"
              >
            </product-themes-tab>

          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canAccessProductWorkflowHistoryTab()" label="Workflow History">
          <ng-template matTabContent>
            
            <product-workflow-history-tab *ngIf="product"
              [product]="product"
              >
            </product-workflow-history-tab>

          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canAccessReferenceMaterialFileVaultBrowserTab()" label="Reference Material">
          <ng-template matTabContent>

            <div class="tab-description">
              A storage repository for reference materials related to the product.
              For guidelines on best practices, refer to the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342/hr4pv-40816" target="_blank">Product References Requirements</a> section of the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342" target="_blank">Product Handbook</a>.
            </div>
            
            <file-vault-browser-tab *ngIf="product"
              [product]="product"
              [fileVaultCategory]="fileVaultCategory.ReferenceMaterial"
              >
            </file-vault-browser-tab>

          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canAccessSourceMaterialFileVaultBrowserTab()" label="Source Material">
          <ng-template matTabContent>
            <div class="tab-description">
              A storage repository for working files used in the production of the product's assets.
              For guidelines on best practices, refer to the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342/hr4pv-40776" target="_blank">Asset Authoring Best Practices</a> section of the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342" target="_blank">Product Handbook</a>.
            </div>
            
            <file-vault-browser-tab *ngIf="product"
              [product]="product"
              [fileVaultCategory]="fileVaultCategory.SourceMaterial"
              >
            </file-vault-browser-tab>

          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canAccessAssetsFileVaultBrowserTab()" label="Assets">
          <ng-template matTabContent>
            <div class="tab-description">
              A storage repository for the final files created in the production of the product's assets.
              For guidelines on best practices, refer to the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342/hr4pv-40776" target="_blank">Asset Authoring Best Practices</a> section of the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342" target="_blank">Product Handbook</a>.
            </div>
            
            <file-vault-browser-tab *ngIf="product"
              [product]="product"
              [fileVaultCategory]="fileVaultCategory.Assets"
              [validateAssets]="true"
              >
            </file-vault-browser-tab>

          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canAccessMarketingMaterialFileVaultBrowserTab()" label="Public Marketing Material">
          <ng-template matTabContent>
            <div class="tab-description">
              A <strong>publicly accessible</strong> storage repository for the files used in the product's callouts. 
              <!-- For guidelines on best practices, refer to the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342/hr4pv-40776" target="_blank">Marketing Material Best Practices</a> section of the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342" target="_blank">Product Handbook</a>. -->
            </div>
            
            <file-vault-browser-tab *ngIf="product"
              [product]="product"
              [fileVaultCategory]="fileVaultCategory.MarketingMaterial"
              >
            </file-vault-browser-tab>

          </ng-template>
        </mat-tab>

        
        <mat-tab *ngIf="canAccessProductPublishTab()" label="Publish">
          <ng-template matTabContent>

            <div class="tab-description">
              Create and publish the product from the assets uploaded to the Assets tab.
              For guidelines on best practices, refer to the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342/hr4pv-40636" target="_blank">Product Categories</a> section of the <a href="https://doc.clickup.com/18617051/d/h/hr4pv-40682/463eb542c289342" target="_blank">Product Handbook</a>.
            </div>
            
            <product-publish-tab *ngIf="product"
              [product]="product"
              [productCompany]="productCompany"
              >
            </product-publish-tab>

          </ng-template>
        </mat-tab>

      </mat-tab-group>

    </mat-card-content>
  </mat-card>

</div>